import styled from 'styled-components';

const Wrapper = styled.div`
  .button--rss {
    display: flex;
    align-items: center;
    gap: 5px;
    height: 34px;
    color: black;
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    border-radius: 3px;
    background-color: transparent;
    text-transform: uppercase;
    cursor: pointer;
    font-family: Roboto;
    border: 1px solid black;
    padding: 7px 12px;
    text-decoration: none;
    transition: all 300ms;

    @media (max-width: 1024px) {
      width: 100%;
    }
  }

  .button--rss:hover {
    background-color: #f0f0f0;
    text-decoration: none;
  }

  .button--rss__img {
    width: 16px;
  }
`;

export { Wrapper };



// WEBPACK FOOTER //
// ./src/components/RSSFluxButton/style.js